import { inject, Injectable } from '@angular/core'
import { Doka360ProjectModel, Doka360ProjectsApiClient } from '@efp/api'
import { firstValueFrom } from 'rxjs'
import { Doka360ProjectsDao } from '../doka360-projects.dao'

@Injectable()
export class Doka360ProjectsHttpDao extends Doka360ProjectsDao {
  private readonly apiClient = inject(Doka360ProjectsApiClient)

  async findOneById(doka360ProjectsUid: string): Promise<Doka360ProjectModel | undefined> {
    return firstValueFrom(
      this.apiClient.getDoka360ProjectById({
        doka360ProjectsUid,
      })
    )
  }
}
